import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class RfqTokenAuthService {
  private readonly tokenKey = 'rfqAccessToken';
  private readonly rfqIdKey = 'rfqId';
  private readonly supplierIdKey = 'rfqSupplierId';

  set(
    rfqAccessToken: string,
    rfqId: string | number,
    supplierId?: string | number | null
  ): void {
    if (rfqAccessToken) sessionStorage.setItem(this.tokenKey, rfqAccessToken);
    if (rfqId !== undefined && rfqId !== null) {
      sessionStorage.setItem(this.rfqIdKey, String(rfqId));
    }
    if (supplierId !== undefined && supplierId !== null) {
      sessionStorage.setItem(this.supplierIdKey, String(supplierId));
    }
  }

  clear(): void {
    sessionStorage.removeItem(this.tokenKey);
    sessionStorage.removeItem(this.rfqIdKey);
    sessionStorage.removeItem(this.supplierIdKey);
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.tokenKey);
  }

  getRfqId(): string | null {
    return sessionStorage.getItem(this.rfqIdKey);
  }

  getSupplierId(): string | null {
    return sessionStorage.getItem(this.supplierIdKey);
  }

  buildAuthHeaders(): { headers: HttpHeaders } | {} {
    const token = this.getToken();
    if (!token) return {};
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    return { headers };
  }
}
